import { useCallback } from 'react'
import type { ScreenShareContext } from './screenShareTypes'
import { startScreenSharingFlow } from './startScreenSharing'
import { stopScreenSharingFlow } from './stopScreenSharing'

export function useScreenShareControls(context: Omit<ScreenShareContext, 'stopScreenSharing'>) {
  const stopScreenSharing = useCallback(async () => {
    await stopScreenSharingFlow({ ...context, stopScreenSharing })
  }, [context])

  const toggleScreenShare = useCallback(async () => {
    if (context.isScreenSharing) {
      await stopScreenSharing()
      return
    }

    await startScreenSharingFlow({ ...context, stopScreenSharing })
  }, [context, stopScreenSharing])

  const toggleMute = useCallback(() => {
    const audioTrack = context.refs.mediaStreamRef.current?.getAudioTracks()[0]
    if (!audioTrack) return

    audioTrack.enabled = !audioTrack.enabled
    context.setIsMuted(!audioTrack.enabled)
    context.showNotification(audioTrack.enabled ? 'Microphone active' : 'Microphone muted')
  }, [context])

  return { stopScreenSharing, toggleScreenShare, toggleMute }
}
